<template>
  <form
    ref="form"
    enctype="multipart/form-data"
    data-url="/evaluator/documentaryEvaluation"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <legend>
      <p class="text-primary">Documentos anteriores</p>
    </legend>
    <div class="row">
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th
                scope="col"
                class="align-middle text-center"
                style="width: 25%"
              >
                USUARIO
              </th>
              <th scope="col" class="text-center" style="width: 15%">
                FECHA DE CREACIÓN
              </th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="accApp && accApp.request_signed">
              <td class="align-middle">Solicitud de Acreditación</td>
              <td class="align-middle text-center">
                {{
                  accApp.request_signed.user
                    ? `${accApp.request_signed.user.first_name} ${accApp.request_signed.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ accApp.request_signed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(accApp, 'request_signed')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <!-- <tr v-if="accApp">
              <td class="align-middle">
                Anexos de la Solicitud de Acreditación
              </td>
              <td class="align-middle text-center">
                {{
                  accApp.user
                    ? `${accApp.user.first_name} ${accApp.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ accApp.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  class="btn btn-success"
                  :href="`/accreditations/applications/${accApp.id}?tab=Anexos`"
                  target="_blank"
                  ><app-icon name="file" /> {{ $t("view") }}</a
                >
              </td>
            </tr> -->
            <tr v-if="evalTest.file_evaluation">
              <td class="align-middle">Propuesta del Equipo Evaluador</td>
              <td class="align-middle text-center">
                {{
                  evalTest.file_evaluation.user
                    ? `${evalTest.file_evaluation.user.first_name} ${evalTest.file_evaluation.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.file_evaluation | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'file_evaluation')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.sampling_plan_file">
              <td class="align-middle">Plan de muestreo</td>
              <td class="align-middle text-center">
                {{
                  evalTest.sampling_plan_file.user
                    ? `${evalTest.sampling_plan_file.user.first_name} ${evalTest.sampling_plan_file.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.sampling_plan_file | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'file_evaluation')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.risk_matrix">
              <td class="align-middle">Matriz de Riesgo</td>
              <td class="align-middle text-center">
                {{
                  evalTest.risk_matrix.user
                    ? `${evalTest.risk_matrix.user.first_name} ${evalTest.risk_matrix.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.risk_matrix | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'risk_matrix')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.evaluation_team_designation">
              <td class="align-middle">Designaciones Equipo Evaluador</td>
              <td class="align-middle text-center">
                {{
                  evalTest.evaluation_team_designation.user
                    ? `${evalTest.evaluation_team_designation.user.first_name} ${evalTest.evaluation_team_designation.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.evaluation_team_designation.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'evaluation_team_designation')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.report_documentary_evaluation">
              <td class="align-middle">Informe de Evaluación Documental</td>
              <td class="align-middle text-center">
                {{
                  evalTest.report_documentary_evaluation.user
                    ? `${evalTest.report_documentary_evaluation.user.first_name} ${evalTest.report_documentary_evaluation.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.report_documentary_evaluation.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'report_documentary_evaluation')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.scope401">
              <td class="align-middle">Alcances</td>
              <td class="align-middle text-center">
                {{
                  evalTest.scope401.user
                    ? `${evalTest.scope401.user.first_name} ${evalTest.scope401.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.scope401.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'scope401')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.first_instance_finding403">
              <td class="align-middle">
                Primera entrega informe para el cierre de hallazgos y decisión
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.first_instance_finding403.user
                    ? `${evalTest.first_instance_finding403.user.first_name} ${evalTest.first_instance_finding403.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ evalTest.first_instance_finding403.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'first_instance_finding403')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.request_additional_evidence">
              <td class="align-middle">Solicitud de Evidencias Adicionales</td>
              <td class="align-middle text-center">
                {{
                  evalTest.request_additional_evidence.user
                    ? `${evalTest.request_additional_evidence.user.first_name} ${evalTest.request_additional_evidence.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.request_additional_evidence.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'request_additional_evidence')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <!-- <tr v-if="evalTest.request_additional_evidence_2">
              <td class="align-middle">
                Segunda Solicitud de Evidencias Adicionales
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.request_additional_evidence_2.user
                    ? `${evalTest.request_additional_evidence_2.user.first_name} ${evalTest.request_additional_evidence_2.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.request_additional_evidence_2.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'request_additional_evidence_2')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->
            <tr v-if="evalTest.second_instance_finding403">
              <td class="align-middle">
                Segunda entrega informe para el cierre de hallazgos y decisión
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.second_instance_finding403.user
                    ? `${evalTest.second_instance_finding403.user.first_name} ${evalTest.second_instance_finding403.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{
                  evalTest.second_instance_finding403.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(evalTest, 'second_instance_finding403')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <hr />
    <!-- <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Evidencia Satisfactoria</label>
          <app-input
            type="radio-buttons"
            v-model="inputs.is_satisfactory"
            :list="confirm"
          />
        </div>
      </div>
      <br />
      <div class="col-sm-6">
        <div class="form-group">
          <label>Informe para el cierre de hallazgos OEC y decisión</label>
          <app-input
            type="file"
            v-model="inputs.file"
            id="evaluation_plan_report"
            :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
            v-if="!inputs.evaluation_plan_report"
          />
          <div>
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab"
              v-if="inputs.evaluation_plan_report"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="inputs.evaluation_plan_report = null"
              v-if="inputs.evaluation_plan_report"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div> -->
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import moment from "moment";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      confirm: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : {};
    },
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      // this.inputs = {
      //   id: this.$store.state.evaluatorReview.evalTest.id,
      //   report_documentary_evaluation: this.$store.state.evaluatorReview
      //     .evalTest.report_documentary_evaluation,
      // };

      this.load();
    },
  },
  created() {
    this.load();
    this.data();
  },
  methods: {
    data() {},

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    load() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          id: this.$store.state.evaluatorReview.evalTest.id,
          report_documentary_evaluation:
            this.$store.state.evaluatorReview.evalTest
              .report_documentary_evaluation,
          file_evaluation:
            this.$store.state.evaluatorReview.evalTest.file_evaluation,
          first_instance_finding403:
            this.$store.state.evaluatorReview.evalTest
              .first_instance_finding403,
          second_instance_finding403:
            this.$store.state.evaluatorReview.evalTest
              .second_instance_finding403,
        };
      }
    },
  },
};
</script>
